import { Location } from "../Admin/Types/state/user.state";
import { decryptByText } from "./bycrypt";

export const formatSecondsToHHMM = (totalSeconds: number): string => {
  if (isNaN(totalSeconds) || totalSeconds < 0) return "00:00";
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const formatMsToHHMM = (totalMs: number): string => {
  if (isNaN(totalMs) || totalMs < 0) return "00:00";
  const h = Math.floor(totalMs / 3600000);
  const m = Math.floor((totalMs % 3600000) / 60000);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export function removeFigureTags(html: string) {
  if (html) {
    const div = document.createElement("div");
    div.innerHTML = html;

    const figures = div.querySelectorAll("figure");
    figures.forEach((figure: any) => {
      while (figure.firstChild) {
        figure.parentNode.insertBefore(figure.firstChild, figure);
      }
      figure.remove();
    });

    return div.innerHTML;
  } else {
    return html;
  }
}
export const paidUnpaidClass = (status: string) => {
  if (status === "paid") {
    return "paidPlanStatus";
  } else if (status === "free") {
    return "activeStatus";
  }
};
export const activeInactiveClass = (status: number) => {
  if (status === 0) {
    return "inactiveStatus";
  } else if (status === 1) {
    return "activeStatus";
  } else if (status === 2) {
    return "inactiveStatus";
  }
};

export function getPageNumber(
  page: number,
  limit: number,
  count: number,
): number {
  // Calculate total pages based on current count and limit
  const totalPages = Math.ceil(count / limit);

  // If the current page exceeds the total pages, return the last page
  if (page > totalPages) {
    return totalPages;
  }

  // Calculate the number of records on the current page after deletion
  const recordsOnCurrentPage = count - (page - 1) * limit;

  // If the current page has no records left after deletion, go to the previous page
  if (recordsOnCurrentPage <= 1 && page > 1) {
    return page - 1;
  }

  return page;
}

export const pageTitle = ({
  PageTitle,
  deletePageTitle,
  isDeleted,
}: {
  PageTitle: string;
  deletePageTitle?: string;
  isDeleted?: number;
}): string => {
  if (isDeleted === 1) {
    return deletePageTitle ? deletePageTitle : PageTitle;
  } else {
    return PageTitle;
  }
};

export const genderText = (gender: "m" | "f" | "o") => {
  if (gender === "m") {
    return "male";
  } else if (gender === "f") {
    return "female";
  } else {
    return "non-binary";
  }
};

export const formatLocation = (location?: Location | null): string => {
  if (location?.city || location?.state) {
    let city = location?.city || "";
    let state = location?.state || "";
    const place = city && state ? `${city}, ${state}` : city || state;
    return place?.length > 0 ? place : "-";
  } else {
    return "-";
  }
};

export const formatName = ({
  fn,
  ln,
}: {
  fn?: string;
  ln?: string;
}): string => {
  if (fn || ln) {
    let f_n = fn ? decryptByText(fn) : "";
    let l_n = ln ? decryptByText(ln) : "";
    return (f_n + l_n)?.length > 0 ? f_n + " " + l_n : "-";
  } else {
    return "-";
  }
};

export function capitalizeName(text?: string) {
  return text || "";
  // let a = text
  //   ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  //   : text;
  // return a;
}

/**number format */
export const formatNumber = (num: number) => {
  // Check if the number is an integer
  if (num) {
    if (Number.isInteger(num)) {
      return num;
    } else {
      return num.toFixed(2);
    }
  } else {
    return null;
  }
};

export interface ParseResult {
  val: number;
  isNaN: boolean;
}

export function parseMaybeNumber(x: unknown): ParseResult {
  if (x === undefined || x === null) return { val: NaN, isNaN: true };

  if (typeof x === "number") {
    if (Number.isFinite(x)) return { val: x, isNaN: false };
    return { val: NaN, isNaN: true };
  }

  const s = String(x).trim();
  if (s === "" || s.toLowerCase() === "nan") return { val: NaN, isNaN: true };

  const n = Number(s);
  if (Number.isFinite(n)) return { val: n, isNaN: false };

  return { val: NaN, isNaN: true };
}

export function range(a: number, b: number, step: number = 1): number[] {
  const r: number[] = [];
  if (step === 0) return r;

  if (step > 0) {
    for (let v = a; v <= b; v += step) r.push(v);
  } else {
    for (let v = a; v >= b; v += step) r.push(v);
  }
  return r;
}

export function sampleEvery<T>(
  arr: T | T[],
  step: number,
  offset: number = 0,
): T[] {
  const source = Array.isArray(arr) ? arr : [arr];
  const out: T[] = [];
  for (let i = offset; i < source.length; i += step) {
    out.push(source[i]);
  }
  return out;
}

export function firstNonZero(x: number | number[]): number {
  if (Array.isArray(x)) {
    for (let i = 0; i < x.length; ++i) {
      const v = x[i];
      if (Number.isFinite(v) && v !== 0) return v;
    }
    return 0;
  }
  if (!Number.isFinite(x)) return 0;
  return x;
}

export function fmtForUI(v: number | number[]): string {
  const val = Array.isArray(v) ? (v.length > 0 ? v[0] : NaN) : v;
  if (!Number.isFinite(val)) return "0.00";
  return Number(val).toFixed(2);
}

export const getCapacitorBaseUrl = (currentUrl: string) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || "";

    const domainMap = [
      {
        match: "dev.3rddigital.com",
        base: "https://dev.3rddigital.com/sm-crm",
      },
      {
        match: "app.sperrinmetal.com",
        base: "https://app.sperrinmetal.com",
      },
    ];

    const matchedDomain = domainMap.find((item) => apiUrl.includes(item.match));
    const baseUrl = matchedDomain ? matchedDomain.base : window.location.origin;
    const url = new URL(currentUrl);
    return `${baseUrl}${url.pathname}${url.search}${url.hash}`;
  } catch (error) {
    return window.location.origin;
  }
};
